import {
  Box,
  Button,
  Container,
  FormControl,
  FormLabel,
  Input,
  Select,
  useToast,
} from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getCourierInfo, getExternalSign, setOrderCourier } from './api';
import {
  getLogis,
  getLogisByName,
  logisModel,
} from 'assets/data/deliveryLogis';
import usePathNavigate from 'lib/hook/usePathNavigate';
import { ResStatus } from 'lib/api/enum';

function RequestParcel() {
  const { pathNavigate, backNavigate } = usePathNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const toast = useToast();

  const [loaded, setLoaded] = useState(false);
  const [orderId, setOrderId] = useState(0);

  const { register, handleSubmit, watch, setValue } = useForm();
  const watchCourierCode = watch('courier_code', '');
  const watchInvoiceNumber = watch('invoice_number', '');
  const onParcelSubmit = async () => {
    const { courier_code, invoice_number } = watch();
    console.log(watch());
    if (loaded === false || courier_code === '' || invoice_number === '')
      return;
    const courierName = getLogisByName(courier_code);
    if (courierName === '') return;

    try {
      const result = await setOrderCourier({
        order_id: orderId,
        courier_id: courier_code,
        courier_name: courierName,
        invoice_num: invoice_number,
      });
      if (result.status === ResStatus.RES_SUCCESS) {
        // pathNavigate('/requestparcel/completed');
        toast({
          title: '저장완료',
          status: 'success',
          duration: 3000,
          isClosable: true,
          position: 'top',
        });
      } else {
        toast({
          title: '오류',
          description: result.result_message,
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top',
        });
      }
    } catch (err: any) {
      console.log('err : ', err);
      toast({
        title: '오류',
        description: err.message,
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'top',
      });
    }
  };

  const getParcelInfoFromToken = async (token: string) => {
    console.log('token : ', token);

    if (token !== null) {
      try {
        const result_sign = await getExternalSign({
          external_token: token,
        });
        if (result_sign.status === ResStatus.RES_SUCCESS) {
          const order_id = result_sign.command.sign_info.order_id;
          const result_courier_info = await getCourierInfo({
            order_id: order_id,
          });
          if (result_courier_info.status === ResStatus.RES_SUCCESS) {
            if (result_courier_info.command.delivery_state > 2) {
              pathNavigate('/requestparcel/expiration');
            } else {
              if (result_courier_info.command.courier_id !== '') {
                setValue(
                  'courier_code',
                  result_courier_info.command.courier_id
                );
              }
              if (result_courier_info.command.invoice_num !== '') {
                setValue(
                  'invoice_number',
                  result_courier_info.command.invoice_num
                );
              }
              setOrderId(order_id);
              setLoaded(true);
            }
          } else {
            toast({
              title: '오류-배송정보',
              description: result_courier_info.result_message,
              status: 'error',
              duration: 3000,
              isClosable: true,
              position: 'top',
            });
          }
        } else {
          toast({
            title: '오류-인증',
            description: result_sign.result_message,
            status: 'error',
            duration: 3000,
            isClosable: true,
            position: 'top',
          });
        }
      } catch (err: any) {
        console.log('err : ', err);
        toast({
          title: '오류',
          description: err.message,
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top',
        });
      }
    } else {
      pathNavigate('/requestparcel/expiration');
    }
  };

  useEffect(() => {
    const token = searchParams.get('t');
    if (token !== null) {
      getParcelInfoFromToken(token);
    }
  }, []);

  return (
    <Box
      as={'form'}
      onSubmit={handleSubmit(onParcelSubmit)}
      px={'16px'}
      py={'38px'}>
      <FormControl>
        <FormLabel fontSize={'14px'} fontWeight={'semibold'} mb={'10px'}>
          택배사
        </FormLabel>
        <Select
          {...register('courier_code')}
          placeholder="택배사를 선택하세요."
          _placeholder={{ color: '#cfcfcf', fontSize: '15px' }}
          my={'0px'}
          fontSize={'15px'}>
          {getLogis().map((option: logisModel) => (
            <option key={option.code} value={option.code}>
              {option.name}
            </option>
          ))}
        </Select>
      </FormControl>
      <FormControl mt={'26px'}>
        <FormLabel fontSize={'14px'} fontWeight={'semibold'} mb={'10px'}>
          송장번호
        </FormLabel>
        <Input
          {...register('invoice_number')}
          placeholder="송장번호를 입력하세요"
          _placeholder={{ color: '#cfcfcf', fontSize: '15px' }}
          fontSize={'15px'}
        />
      </FormControl>
      <Button
        isDisabled={
          (loaded === false && watchCourierCode === '') ||
          watchInvoiceNumber === ''
        }
        mt={'34px'}
        height={'56px'}
        colorScheme="black_button"
        type="submit"
        width="100%"
        fontSize={'16px'}>
        등록 · 변경
      </Button>
    </Box>
  );
}

export default RequestParcel;
